import QRCode from "react-qr-code";
import { translate } from "../../translations/index.ts";

export default function WaitingScreen({ code, participants }) {
  // NOTE: This gives a bit of a weird result in dev mode, but works in production
  const joinURL = new URL("/join", import.meta.url);
  const path = `/votingsession/${code}`; // Keep this outside of `new URL()` - otherwise vite build a wrong url
  const directURL = new URL(path, import.meta.url);
  return (
    <>
      <h1 className="voting-session__title">
        {translate("teacher.votingSession.waitingScreen.title.firstLine")}
        <br />
        <span className="--highlighted">
          {translate("teacher.votingSession.waitingScreen.title.secondLine")}
        </span>
      </h1>
      <div className="waiting-screen">
        <h2 className="waiting-screen__title">
          {translate("teacher.votingSession.waitingScreen.instructions", {
            url: joinURL.toString(),
          })}
        </h2>

        <div className="waiting-screen__content">
          <QRCode
            value={directURL.toString()}
            size={400}
            className="waiting-screen__qr-code"
          />

          <div className="waiting-screen__code">
            <p className="waiting-screen__code-title">
              {translate("teacher.votingSession.waitingScreen.code")}
            </p>
            {code}
          </div>
        </div>

        <div className="waiting-screen__participants">
          {translate("teacher.votingSession.waitingScreen.participantsCount")}
          <span className="waiting-screen__participants-count">
            {participants}
          </span>
        </div>
      </div>
    </>
  );
}
